import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { routes } from "../Routes/Routes";

const { useUnoSelector } = UnoStoreHooks;

const Layout = () => {
  const userData = useUnoSelector((state) => state.user);
  const isLoggedIn = userData?.token ? true : false;
  const defaultRoute = isLoggedIn ? "/dashboard" : "/gateway";
  const routesToDisplay = (isLoggedIn ? routes.private : routes.public) || [];

  return (
    <Routes>
      {routesToDisplay.map((route) => {
        const LayoutToRender = route.layout;
        const ElementToRender = route.elem;
        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              <LayoutToRender>
                <ElementToRender />
              </LayoutToRender>
            }
          />
        );
      })}
      <Route path="*" element={<Navigate to={defaultRoute} />} />
    </Routes>
  );
};

export default Layout;
